import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { CandidateDetailsComponent } from '@app/shared/candidatedetails/candidatedetails.component';
import { BirthdayValidator, EmptyStringValidator, MustMatch } from '@app/_helpers';
import { Education, Employer, levelOfEducation, orderType, Signup } from '@app/_models';
import { CreditCheck } from '@app/_models/creditCheck';
import { Candidate, CurrentAddress, Order } from '@app/_models/orders/shared';
import { Country, County, State } from '@app/_models/signups/geography';
import { AlertService, GeographyService, SignupService } from '@app/_services';
import { TooltipMessageService } from '@app/_services/toolservice.service';
import { breakpointPixels, FadvCheckboxComponent, FadvIconLibraryService, FadvModalComponent, FadvScrollerComponent } from '@fa-switch-sharedservices/ng-elements';
import { Subscription } from 'rxjs';
import { PartnerComponent } from '../partner.component';

@Component({
  selector: 'app-partner-online',
  templateUrl: './partner-online.component.html',
  styleUrls: ['./partner-online.component.css']
})
export class PartnerOnlineComponent implements OnInit {
  form: UntypedFormGroup;
  loading = false;
  submitted = false;
  orderType = orderType;
  requireMiddleName = false;
  states: State[];
  countries: Country[];
  counties: County[];
  selectedState: string;
  selectedCounty: string;
  signup: Signup;
  orderHeaderVerbiage: string;
  orderSubHeaderVerbiage: string;
  middleNameToggle: Subscription;
  formModalOpen = false;
  inviteOrder = true;
  requireDL = false;
  displayInvite = false;
  innerWidth: number;
  backButtonAlignment: string = "right";
  nextButtonAlignment: string = "left";
  consentButtonAlignment: string = "right";
  cancelButtonAlignment: string = "left";
  employmentRequired = false;
  previousEmployers: Employer[] = [];
  educationRequired = false;
  creditCheckRequired = false;
  institutions: Education[] = [];
  creditChecks: CreditCheck[] = [];
  @ViewChild('candidateDetailsComponent') candidateDetailsComponent: CandidateDetailsComponent;
  @ViewChild('consentmodal') consentmodal!: FadvModalComponent;
  @ViewChild('signedConsentModal') signedConsentModal: FadvModalComponent;
  @ViewChild('releaseCheckbox') releaseCheckbox!: FadvCheckboxComponent;
  @ViewChild('fadvScroller') fadvScroller!: FadvScrollerComponent;
  addressTooltip: string;
  legalNameTooltip: string;
  levelsOfEducation: any;
  hasIncludedEmployment: boolean;
  hasIncludedEducation: boolean;
  hasIncludedCredit: boolean;


  constructor(private formBuilder: UntypedFormBuilder,
    private router: Router,
    private geographyService: GeographyService,
    private signupService: SignupService,
    private cdref: ChangeDetectorRef,
    private tooltipMessenger: TooltipMessageService,
    private partnerComponent: PartnerComponent,
    private appComponent: AppComponent,
  ) { }

  ngOnInit(): void {
    this.handleViewChange();
    this.handleGeographyService();
    this.handleGetSignup();
    this.handleBuildForm();
    this.handleToolTips();
    this.handleMiddleName();
    this.handleRequireDL();
    this.handleRequireCredit();
    this.handleRequireEducation();
    this.handleRequireEmployment();
    this.handlePatchedValues();
    this.levelsOfEducation = levelOfEducation;

    this.partnerComponent.setStep(this.router.url);
    this.candidate.updateValueAndValidity();
  }

  get orderForm() { return this.form.get('order') as UntypedFormGroup };
  get candidate() { return this.orderForm.get('candidate') as UntypedFormGroup };
  get currentAddress() { return this.orderForm.get('currentAddress') as UntypedFormGroup };
  get employment() { return this.orderForm.get('employment') as UntypedFormGroup };
  get education() { return this.orderForm.get('education') as UntypedFormGroup };

  @HostListener('window:resize', ['$event'])

  onResize(event) {
    this.handleViewChange();
  }

  handleViewChange(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < breakpointPixels.md) {

      this.backButtonAlignment = 'center';
      this.nextButtonAlignment = 'center';
      this.consentButtonAlignment = 'center';
      this.cancelButtonAlignment = 'center';
    } else {
      this.backButtonAlignment = 'right';
      this.nextButtonAlignment = 'left';
      this.consentButtonAlignment = 'right';
      this.cancelButtonAlignment = 'left';
    }
  }

  handleBuildForm() {
    this.form = this.formBuilder.group({

      ordertype: ['online', [Validators.required]],
      // haveSignedRelease: [false, Validators.requiredTrue],

      order: this.formBuilder.group({
        candidate: this.formBuilder.group({
          firstName: ['', [Validators.required, Validators.pattern('[a-z A-Z  -\/:-@\[-\`{-~]+$'), EmptyStringValidator]],
          middleNameRequired: [''],
          middleName: [''],
          lastName: ['', [Validators.required, Validators.pattern('[a-z A-Z  -\/:-@\[-\`{-~]+$'), EmptyStringValidator]],
          ssn: ['', [Validators.required, Validators.minLength(9), Validators.pattern(/^-?(|[0-9]\d*)?$/)]],
          dob: ['', [Validators.required, BirthdayValidator]],
          email: ['', [Validators.required, Validators.email]],
          confirmEmail: ['', Validators.required],
          dlNumber: ['', this.requireDL ? Validators.required : null],
          dlState: ['', this.requireDL ? Validators.required : null]
        }, { validators: MustMatch("email", "confirmEmail") }),

        currentAddress: this.formBuilder.group({
          addressLine1: [this.signup.order.currentAddress.addressLine1 != undefined ? this.signup.order.currentAddress.addressLine1 : '', Validators.required],
          addressLine2: [this.signup.order.currentAddress.addressLine2 != undefined ? this.signup.order.currentAddress.addressLine2 : ''],
          county: ['', Validators.required],
          zip: [this.signup.order.currentAddress.zip != undefined ? this.signup.order.currentAddress.zip : '', [Validators.required, Validators.minLength(5), Validators.pattern(/^-?(|[0-9]\d*)?$/)]],
          city: [this.signup.order.currentAddress.city != undefined ? this.signup.order.currentAddress.city : '', Validators.required],
          state: [this.signup.order.currentAddress.zip != undefined ? this.signup.order.currentAddress.state : '', [Validators.required, Validators.pattern('[a-z A-Z]+$'), EmptyStringValidator]],
          country: ['US', Validators.required],
        }),
        employment: this.formBuilder.group({
          employerName: [''],
          startDate: [''],
          endDate: [''],
          position: [''],
          city: [''],
          state: [''],
          phone: [''],
          isCurrentEmployer: false
        }),
        education: this.formBuilder.group({
          institutionName: [''],
          startDate: [Date],
          endDate: [Date],
          levelOfEducation: [''],
          city: [''],
          state: [''],
          fieldOfStudy: [''],
          nameAttendedUnder: [''],
          typeOfDegree: [''],
          acquiredDegree: false,
          dateAwarded: ['']
        }),
      }),
    })
  }

  handleGetSignup() {
    this.signup = this.signupService.getSignup();
    this.signup.ordertype = orderType.online;
    if (this.signup.order == undefined) {
      this.signup.order = new Order();
    }
    if (this.signup.order.candidate == undefined) {
      this.signup.order.candidate = new Candidate();
    }
    if (this.signup.order.currentAddress == undefined) {
      this.signup.order.currentAddress = new CurrentAddress();
    }
    if (this.appComponent.partner == false) {
      this.handleRefresh();
    }
  }

  handleRefresh() {
    this.appComponent.partner = true;
    var logo = this.signup.partner.logoImageContentType + this.signup.partner.logo;
    this.appComponent.partnerLogo = logo;
  }

  handleToolTips() {
    this.newTooltip();
    this.newCurrentAddressMessage();
    this.tooltipMessenger.currentAddressTooltip.subscribe(addressTooltip => this.addressTooltip = addressTooltip);
    this.tooltipMessenger.currentNameMessage.subscribe(legalNameTooltip => this.legalNameTooltip = legalNameTooltip);
  }

  handleZipCodeChange(zip: string) {
    this.geographyService.getStatesByPostalCode(zip).subscribe(response => {
      this.selectedState = response[0]['name'];
      this.currentAddress.patchValue({ state: response[0]['name'] });
      this.geographyService.getCounties(zip, this.selectedState).subscribe(counties => {
        this.counties = counties;
        if (counties.length === 1) {
          this.currentAddress.patchValue({ county: this.counties[0].Key });
          this.selectedCounty = this.counties[0].Key;
        }
      })
    });
  }

  handleGeographyService() {
    this.geographyService.getStates().subscribe(states => this.states = states);
    this.geographyService.getCountries().subscribe(countries => this.countries = countries);
  }

  handleRequireEmployment() {
    if (this.signup.order.addOnProducts.find(x => x == 456) || this.signup.package?.productDescriptions.find(x => x.id == 456)) {
      this.employmentRequired = true;
      this.setEmploymentValidators();
    }
    else {
      this.removeEmploymentValidators();
    }
  }

  handleRequireCredit() {
    if (this.signup.order.addOnProducts.find(x => x == 296) || this.signup.package?.productDescriptions.find(x => x.id == 296)) {
      this.creditCheckRequired = true;
    }
  }

  handleRequireEducation() {
    if (this.signup.order.addOnProducts.find(x => x == 312) || this.signup.package?.productDescriptions.find(x => x.id == 312)) {
      this.educationRequired = true;
      this.setEducationValidators();
    }
    else {
      this.removeEducationValidators();
    }
  }

  handleRequireDL() {
    if (this.signup.order.addOnProducts.find(x => x == 306 || x == 1386) || this.signup.package?.productDescriptions.find(x => x.id == 306 || x.id == 1386)) {
      this.requireDL = true;
    }
    if (this.requireDL) {
      this.handleRequireDLValidation();
    }
  }



  handlePatchedValues() {
    this.candidate.updateValueAndValidity();

    if (this.signup.order.candidate.dob != null) {
      this.candidate.patchValue({ dob: this.signup.order.candidate.dob })
    }

    this.orderHeaderVerbiage = "Applicant Details";
    this.orderSubHeaderVerbiage = "Please Complete Your Applicant's Details and Confirm You Have Received Consent. \n In accordance with the Fair Credit Reporting Act (FCRA), companies must notify candidates/employees with a stand-alone written document before requesting consumer information from a third-party."
    if (this.signup != undefined) {

      if (this.signup.order != undefined) {
        if (this.signup.order.candidate.middleName != undefined) {
          this.candidate.patchValue({ middleNameRequired: '1' });
          this.candidate.patchValue({ middleName: this.signup.order.candidate.middleName })
        }
      }

      if (this.signup.candidatefirstname != undefined) {
        this.candidate.patchValue({ firstName: this.signup.candidatefirstname })
      }

      if (this.signup.candidatemiddlename != undefined) {
        this.candidate.patchValue({ middleName: this.signup.candidatemiddlename })
      }

      if (this.signup.candidatelastname != undefined) {
        this.candidate.patchValue({ lastName: this.signup.candidatelastname })
      }

      if (this.signup.order.candidate.email != undefined) {
        this.candidate.patchValue({ email: this.signup.order.candidate.email })
      }

      if (this.signup.order.candidate.dob != undefined && this.candidateDetailsComponent != undefined) {
        this.setDob(this.signup.order.candidate.dob);
        this.candidateDetailsComponent.dobTemp = this.signup.order.candidate.dob;
      }
    }
  }

  handleMiddleName() {
    this.middleNameToggle = this.candidate.get('middleNameRequired').valueChanges.subscribe(x => {
      this.requireMiddleName = x === '1';
      if (this.requireMiddleName) {
        this.candidate.setControl("middleName", new UntypedFormControl({ value: '', disabled: false },
          [Validators.pattern('[a-z A-Z  -\/:-@\[-\`{-~]+$'), EmptyStringValidator]));
        this.candidate.updateValueAndValidity();
      }
      else {
        this.candidate.setControl("middleName", new UntypedFormControl({ value: '', disabled: true }));
        this.candidate.updateValueAndValidity();
      }
    });
  }


  handleRequireDLValidation() {
    this.candidate.controls.dlNumber.addValidators([Validators.required, EmptyStringValidator]);
    this.candidate.controls.dlState.addValidators([Validators.required, Validators.pattern('^[a-zA-Z]+$'), EmptyStringValidator]);
  }

  setDob(dob: Date) {
    this.candidate.patchValue({ dob: new Date(dob) });

    if (this.candidate.controls.dob.invalid) {
      this.tooltipMessenger.hideDobPicker(false);
    }
    else {
      this.tooltipMessenger.hideDobPicker(true);
    }
  }

  setSSN(incomingSSN: string) {
    this.candidate.patchValue({ ssn: incomingSSN });
  }

  endDateValidator(event: any) {
    if (event) {
      var today = new Date();
      this.employment.controls.endDate.setErrors({ 'invalid': false });
      this.employment.setControl("endDate", new UntypedFormControl({ value: today, disabled: false }));
    }
    else {
      this.employment.controls.endDate.setErrors({ 'invalid': true });
      this.employment.controls.endDate.addValidators([Validators.required]);
    }
  }
  // submit order, move to next step
  onSubmit() {
    this.submitted = true;
    this.loading = true;

    if (this.form.invalid) {
      this.loading = false;
      return;
    }

    this.signup.candidateemail = this.form.value.order.candidate.email;
    this.signup.candidatefirstname = this.form.value.order.candidate.firstName;
    this.signup.candidatelastname = this.form.value.order.candidate.lastName;
    this.signup.candidatemiddlename = this.form.value.order.candidate.middleName;

    this.signup.order.candidate.firstName = (this.orderForm.get('candidate') as UntypedFormGroup).controls.firstName.value;
    this.signup.order.candidate.middleName = (this.orderForm.get('candidate') as UntypedFormGroup).controls.middleName.value;
    this.signup.order.candidate.lastName = (this.orderForm.get('candidate') as UntypedFormGroup).controls.lastName.value;
    this.signup.order.candidate.email = (this.orderForm.get('candidate') as UntypedFormGroup).controls.email.value;
    this.signup.order.candidate.ssn = (this.orderForm.get('candidate') as UntypedFormGroup).controls.ssn.value;
    this.signup.order.candidate.dob = (this.orderForm.get('candidate') as UntypedFormGroup).controls.dob.value;
    this.signup.order.candidate.dlNumber = (this.orderForm.get('candidate') as UntypedFormGroup).controls.dlNumber.value;
    this.signup.order.candidate.dlState = (this.orderForm.get('candidate') as UntypedFormGroup).controls.dlState.value;

    this.signup.order.currentAddress.addressLine1 = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.addressLine1.value;
    this.signup.order.currentAddress.addressLine2 = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.addressLine2.value;
    this.signup.order.currentAddress.county = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.county.value;
    this.signup.order.currentAddress.zip = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.zip.value;
    this.signup.order.currentAddress.city = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.city.value;
    this.signup.order.currentAddress.state = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.state.value;
    this.signup.order.currentAddress.country = (this.orderForm.get('currentAddress') as UntypedFormGroup).controls.country.value;

    if (this.employmentRequired == true) {
      this.addPreviousEmployer();
    }
    if (this.educationRequired == true) {
      this.addEducation();
    }
    if (this.creditCheckRequired == true) {
      this.addCreditCheck();
    }
    this.signup.order.previousEmployers = this.previousEmployers;
    this.signup.order.education = this.institutions;
    this.signup.order.creditCheck = this.creditChecks;
    this.signupService.saveCandidateDetails(this.signup);
    this.router.navigate(['/partner/payment'])
  }

  selectOrderType(order: string): void {
    this.signup.ordertype = orderType[order];
    this.router.navigate(['/partner/invite'])
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  onCancel() {
    this.router.navigate(['/partner/candidate'])
  }

  showFormModal() {
    this.consentmodal.show();
  }

  hideFormModal() {
    this.consentmodal.hide();
  }

  newTooltip() {
    this.tooltipMessenger.changeNameMessage("Please provide your applicant's legal name at it appears on their government issued identification to ensure accuracy when searching and verifying record data.")
  }

  newCurrentAddressMessage() {
    this.tooltipMessenger.changeTooltip("Please provide the address for the applicant's current place of residence.")
  }

  showSignedConsentModal() {
    this.signedConsentModal.show();
  }

  addPreviousEmployer() {
    var inputEmployer = new Employer();

    inputEmployer = this.orderForm.get('employment').value;
    if (this.orderForm.get('employment').value.isCurrentEmployer) {
      inputEmployer.isCurrentEmployer = true;
    }
    else {
      inputEmployer.isCurrentEmployer = false;
    }
    this.previousEmployers.push(inputEmployer);
    this.orderForm.get('employment').reset();
    this.hasIncludedEmployment = true;
  }

  addEducation() {
    var inputEducation = new Education();
    inputEducation = this.education.value;

    inputEducation.acquiredDegree = this.education.controls.acquiredDegree.value;

    if (inputEducation.acquiredDegree == false || inputEducation.acquiredDegree == null) {
      inputEducation.dateAwarded = "Did not recieve degree";
      inputEducation.acquiredDegree = false;
    }
    else {
      inputEducation.acquiredDegree = true;
    }

    if (inputEducation.levelOfEducation != "College") {
      inputEducation.typeOfDegree = ""
    }

    this.institutions.push(inputEducation);
    this.orderForm.get('education').reset();
    this.hasIncludedEducation = true;
  }

  addCreditCheck() {
    var inputCredit = new CreditCheck();
    inputCredit.FirstName = this.candidate.controls.firstName.value;
    inputCredit.LastName = this.candidate.controls.lastName.value;
    inputCredit.Address1 = this.currentAddress.controls.addressLine1.value;
    inputCredit.Address2 = this.currentAddress.controls.addressLine2.value;
    inputCredit.City = this.currentAddress.controls.city.value;
    inputCredit.State = this.currentAddress.controls.state.value;
    inputCredit.ZipCode = this.currentAddress.controls.zip.value;
    inputCredit.IDType = "SSN";
    inputCredit.IDNumber = this.candidate.controls.ssn.value;

    this.creditChecks.push(inputCredit);
    this.hasIncludedCredit = true;

  }

  setEmploymentValidators() {
    this.employment.controls.employerName.addValidators([Validators.required, EmptyStringValidator]);
    this.employment.controls.startDate.addValidators([Validators.required]);
    this.employment.controls.endDate.addValidators([Validators.required]);
    this.employment.controls.position.addValidators([Validators.required, EmptyStringValidator]);
    this.employment.controls.city.addValidators([Validators.required, EmptyStringValidator]);
    this.employment.controls.state.addValidators([Validators.required]);
    this.employment.controls.phone.addValidators([Validators.required, EmptyStringValidator, Validators.pattern(/^-?(|[0-9]\d*)?$/)]);
    this.employment.updateValueAndValidity();
  }

  setEducationValidators() {
    this.education.controls.institutionName.addValidators([Validators.required, EmptyStringValidator]);
    this.education.controls.nameAttendedUnder.addValidators([Validators.required, EmptyStringValidator]);
    this.education.controls.startDate.addValidators([Validators.required]);
    this.education.controls.endDate.addValidators([Validators.required]);
    this.education.controls.levelOfEducation.addValidators([Validators.required]);
    this.education.controls.fieldOfStudy.addValidators([Validators.required, EmptyStringValidator]);
    this.education.controls.state.addValidators([Validators.required]);
    this.education.controls.city.addValidators([Validators.required, EmptyStringValidator]);
    this.education.updateValueAndValidity();
  }

  removeEmploymentValidators() {
    this.employment.setControl("employerName", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.setControl("startDate", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.setControl("endDate", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.setControl("position", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.setControl("state", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.setControl("city", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.setControl("phone", new UntypedFormControl({ value: '', disabled: false }));
    this.employment.updateValueAndValidity();
  }

  removeEducationValidators() {
    this.education.setControl("institutionName", new UntypedFormControl({ value: '', disabled: false }));
    this.education.setControl("nameAttendedUnder", new UntypedFormControl({ value: '', disabled: false }));
    this.education.setControl("startDate", new UntypedFormControl({ value: '', disabled: false }));
    this.education.setControl("endDate", new UntypedFormControl({ value: '', disabled: false }));
    this.education.setControl("levelOfEducation", new UntypedFormControl({ value: '', disabled: false }));
    this.education.setControl("fieldOfStudy", new UntypedFormControl({ value: '', disabled: false }));
    this.education.setControl("state", new UntypedFormControl({ value: '', disabled: false }));
    this.education.setControl("city", new UntypedFormControl({ value: '', disabled: false }));
    this.education.setControl("dateRecieved", new UntypedFormControl({ value: '', disabled: false }));
    this.education.updateValueAndValidity();
  }
}